export class Instructor{
    name: string;
    id: number;
    url: string;
    title: string;
    image: string;
}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/models/instructor.model.ts